














import Vue from 'vue'
import Component from 'vue-class-component'
import { Prop } from 'vue-property-decorator'
import { State } from 'vuex-class'

import TransactionHelperComponents2Header from './transaction-helper-components-2-header.vue'

// const namespace = 'digitalCurrency'

@Component({
  name: 'TransactionHelperComponents1MainPage',
  components: {
    TransactionHelperComponents2Header
  }
})
class TransactionHelperComponents1MainPage extends Vue {
  @State('isMobileDevice') isMobileDevice?: boolean

  @Prop({ default: '' }) transactionId?: string
  @Prop({ default: false }) showInNav?: boolean

  @Prop({ default: true }) openWebsitePageInNewTab?: boolean

  @Prop({ default: '' }) transactionOwnerAccountId?: string


  emitToggleShowContent ({ contentName, isVisible }: { contentName: string, isVisible?: boolean}) {
    this.$emit('toggleShowContent', { contentName, isVisible })
  }

  openFolderOrFileItem (dataTableFileItem: any) {
    this.$emit('openFolderOrFileItem', dataTableFileItem)
  }

  navigateBackToPreviousFileItem (deleteFileItem?: boolean) {
    this.$emit('navigateBackToPreviousFileItem', deleteFileItem)
  }
}
export default TransactionHelperComponents1MainPage
